import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import _get from 'lodash/get';
import { validate } from '../lib/clientValidator';
import VxRadioField from './vxFields/VxRadioField';
import VxBasicInputField from './vxFields/VxBasicInputField';
import VxBasicSelectField from './vxFields/VxBasicSelectField';
import PropTypes from 'prop-types';
import { BTN_FACTORY_FORM } from '../clientConstants';
import { connect } from 'react-redux';
import getLocaleMessages from '../utils/localesMessages';
import { isLoggedInUser } from '../utils/authUtils';
import { formatAmount } from '../utils/amountUtils';
import { trackWizardStep } from '../utils/ButtonFactoryFPT';
import $ from 'jquery';

const {
	header,
	subTitle,
	advance,
	currencyInput,
	amountTypeRadio,
	recurringRadio,
	finish,
	tooltip = {}
} = getLocaleMessages('buttons/wizardStepThree');

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state) || {};
	const currencyMetadata = _get(state, 'application.currencyMetadata');

	return {
		initialValues: state.buttonFactory.formattedButton,
		formValues,
		receivableCurrency: state.application.receivableCurrency,
		application: state.application,
		currencyDetail: currencyMetadata
	}
}

class WizardStep3 extends Component {
	static propTypes = {
		formValues: PropTypes.object,
		handleSubmit: PropTypes.func,
		onSubmit: PropTypes.func,
		usePaypalButtonStyle: PropTypes.bool,
		buttonSize: PropTypes.string,
		showAcceptedCardLogos: PropTypes.bool,
		receivableCurrency: PropTypes.array,
		application: PropTypes.object,
		currencyDetail: PropTypes.object,
		change: PropTypes.func
	}

	componentDidMount() {
		$('.main-container').animate({ scrollTop: 0 }, 400);

		trackWizardStep({
			step: 3
		});
	}

	renderReceivableCurrency = (props) => {
		const options = [
			{ value: '', displayValue: `${currencyInput.selectAValue}` },
			...this.props.receivableCurrency
		];
		return (
			<VxBasicSelectField
				options={options}
				{...props}
			/>
		)
	}

	renderAmountTypeFixed = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	renderAmountTypeVariable = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	renderAmountValueField = (props) => {
		return (
			<VxBasicInputField
				{...props}
			/>
		)
	}

	renderAmountTypePreset = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}
	
	renderAmountTypeDynamic = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	renderRecurringDisabled = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	renderRecurringEnabled = (props) => {
		return (
			<VxRadioField {...props} />
		)
	}

	getApplicationValues = (key) => {
		return _get(this.props.application, key, false);
	}

	getValue = (key) => {
		return this.props.formValues[key];
	}

	handleAmountFormatChange = (event, currency) => {
		const amountType = this.getValue('amountType');
		if (amountType === 'fixed') {
			// Update amount field once currency changes
			const value = this.getValue('amountValue');
			const formattedAmount = formatAmount(value, currency);
			this.props.change('amountValue', formattedAmount);
		} else if (amountType === 'merchant_recommended') {
			const merchantAmount1 = this.getValue('merchantAmount1');
			const formattedAmount1 = formatAmount(merchantAmount1, currency);
			this.props.change('merchantAmount1', formattedAmount1);

			const merchantAmount2 = this.getValue('merchantAmount2');
			const formattedAmount2 = formatAmount(merchantAmount2, currency);
			this.props.change('merchantAmount2', formattedAmount2);

			const merchantAmount3 = this.getValue('merchantAmount3');
			const formattedAmount3 = formatAmount(merchantAmount3, currency);
			this.props.change('merchantAmount3', formattedAmount3);
		}
	}

	render() {
		const { handleSubmit } = this.props;
		const amountType = this.getValue('amountType');
		const recurringEnabled = this.getValue('recurringEnabled');
		const isLoggedIn = isLoggedInUser(this.props.application);
		const isHosted = ['BUSINESS', 'PREMIER'].includes(this.getApplicationValues('userType'));
		const currency = this.getValue('receiverCurrency');
		const formattedAmount = value => value && formatAmount(value, currency);
		const enableMerchantPresetAmount = this.getApplicationValues('enableMerchantPresetAmount');
		const enableRecurring = this.getApplicationValues('enableRecurring');

		return (
			<div className="wizard-step-container wizard-step-3-container">
				<div className="wizard-step-title">
					{header}
					{!isLoggedIn &&
						<div className="vx_text-legal">{subTitle}</div>
					}
				</div>
				<div className="wizard-body">
					<form className="wizard-form">
						<Field
							id="receiverCurrency"
							name="receiverCurrency"
							component={this.renderReceivableCurrency}
							label={currencyInput.label}
							onChange={this.handleAmountFormatChange}
							tooltipContent={tooltip.currency}
							tooltipId="tooltip-currency"
							tooltipPlacement="top"
						/>

						<p className="vx_text-body custom-margin-top-1">{amountTypeRadio.label}</p>
						<Field
							type="radio"
							id="amountTypeVariable"
							name="amountType"
							value="variable"
							checkedValue={amountType}
							component={this.renderAmountTypeVariable}
							label={amountTypeRadio.variable}
						/>

						<Field
							type="radio"
							id="amountTypeFixed"
							name="amountType"
							value="fixed"
							checkedValue={amountType}
							component={this.renderAmountTypeFixed}
							label={amountTypeRadio.fixed}
						/>

						{
							amountType === 'fixed' ?
							<div className="fields-margin-left fixed-amount">
								<Field
									name="amountValue"
									id="amountValue"
									component={this.renderAmountValueField}
									label={amountTypeRadio.amount}
									normalize={formattedAmount}
								/>
							</div> :
							null
						}
						{enableMerchantPresetAmount && isHosted &&
							<Field
								type="radio"
								id="amountTypePreset"
								name="amountType"
								value="merchant_recommended"
								checkedValue={amountType}
								component={this.renderAmountTypePreset}
								label={amountTypeRadio.preset}
								tooltipContent={tooltip.merchantPresetAmount}
								tooltipId="tooltip-merchant-preset-amount"
								tooltipPlacement="top"
							/>
						}
						{amountType === 'merchant_recommended' &&
							<div className="preset-amount">
								<div className="amount-option">
									<span className="help-note-mobile">{amountTypeRadio.option1}</span>
									<Field
										name="merchantAmount1"
										id="merchantAmount1"
										component={this.renderAmountValueField}
										label={amountTypeRadio.amount}
										normalize={formattedAmount}
										helpText={amountTypeRadio.option1}
									/>
								</div>
								<div className="amount-option">
									<span className="help-note-mobile">{amountTypeRadio.option2}</span>
									<Field
										name="merchantAmount2"
										id="merchantAmount2"
										component={this.renderAmountValueField}
										label={amountTypeRadio.amount}
										normalize={formattedAmount}
										helpText={amountTypeRadio.option2}
									/>
								</div>
								<div className="amount-option">
									<span className="help-note-mobile">{amountTypeRadio.option3}</span>
									<Field
										name="merchantAmount3"
										id="merchantAmount3"
										component={this.renderAmountValueField}
										label={amountTypeRadio.amount}
										normalize={formattedAmount}
										helpText={amountTypeRadio.option3}
									/>
								</div>
								<div className="amount-option other">
									<span className="other-amount">{amountTypeRadio.other}</span>
								</div>
							</div>
						}
						{enableRecurring && isHosted &&
							<div>
								<p className="vx_text-body custom-margin-top-2">{recurringRadio.label}</p>
								<Field
									type="radio"
									id="recurringDisabled"
									name="recurringEnabled"
									value="no"
									checkedValue={recurringEnabled}
									component={this.renderRecurringDisabled}
									label={recurringRadio.no}
								/>

								<Field
									type="radio"
									id="recurringEnabled"
									name="recurringEnabled"
									value="yes"
									checkedValue={recurringEnabled}
									component={this.renderRecurringEnabled}
									label={recurringRadio.yes}
								/>
							</div>
						}

					</form>
				</div>
				<div className="wizard-footer-button">
					<button className="vx_btn" type="submit" onClick={handleSubmit} id="nextStep">
						{isLoggedIn && isHosted ? advance : finish}
					</button>
				</div>
			</div>

		);
	}
}

let WizardStep3Form = reduxForm({
	form: BTN_FACTORY_FORM,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate
})(WizardStep3);

WizardStep3Form = connect(mapStateToProps)(WizardStep3Form);

export default WizardStep3Form;



// WEBPACK FOOTER //
// ./buttons/components/WizardStep3.js